import * as React from 'react';
import {withStyles, WithStyles} from '@material-ui/core';
import TranslateNew from '@translate/TranslateNew';
import { ChatStyle } from './Chat.style';
import { ISuggestion } from '@app-types/websocket/suggestion.types';
import { SUGGESTION_CHANGE_TYPES, SUGGESTION_TYPES } from '@constants/suggestionTypes';
import { Link } from 'react-router-dom';
import { IFamilyMember } from '@app-types/websocket/family.types';
import ArrowIcon from "@material-ui/icons/ArrowForwardIosRounded";
import AcceptIcon from '@material-ui/icons/ThumbUpRounded';
import DeclineIcon from '@material-ui/icons/ThumbDownRounded';
import DeleteIcon from '@material-ui/icons/DeleteForeverRounded';
import ImgAvatar from '@components/common/avatar/ImgAvatar';
import InfoIcon from '@material-ui/icons/InfoOutlined';
import ReplyIcon from '@material-ui/icons/ReplyRounded';
import { styleColors } from 'src/main.style';


const tn: TranslateNew = TranslateNew.getInstance();

interface IProps extends WithStyles<typeof ChatStyle> {
  userId:number;
  suggestion:ISuggestion;
  family:IFamilyMember[];
  showSuggestionDetails:() => void;
}

class ChatSuggestionMessage extends React.Component<IProps> {

  constructor(props: IProps) {
    super(props);
  }

  public render() {

    const {classes, suggestion, userId, family} = this.props;

    let nameCreator:JSX.Element|undefined 
    let avatarCreator:JSX.Element|undefined 
    

    const creator: IFamilyMember|undefined = family.find((f) => f.id === suggestion.creatorId);
    let respondant: IFamilyMember|undefined;

    if (suggestion.responseAccountId) {
      respondant = family.find((f) => f.id === suggestion.responseAccountId);
    }
    const timeCreated:JSX.Element|undefined = <div className={classes.chatTime} style={suggestion.creatorId === userId?{right:'4px'}:{left:'4px'}}>
            {tn.formatTime(new Date(suggestion.publishTime))}
          </div>

    if (creator) {
      nameCreator = <div style={{color:creator.color}} className={classes.chatMessageSender}>{creator.firstName}</div>
      avatarCreator = <ImgAvatar imgName={creator.avatar} color={creator.color} border={true} style={{width: 28,height: 28, borderWidth:'2px'}}
        imgUrl={creator.imageAvatar ? creator.avatarURL : undefined} />;
    } else {
      nameCreator = <div style={{color:styleColors.greyMedium1}} className={classes.chatMessageSender}>{tn.lang.unknown}</div>
      avatarCreator = <div className={classes.chatIconAvatar} />;
    }
    
    let nameRespondant:JSX.Element|undefined 
    let avatarRespondant:JSX.Element|undefined 
    let timeRespondant:JSX.Element|undefined 
    let response:JSX.Element|undefined 

    if (respondant && !((suggestion.status === SUGGESTION_TYPES.DELETED ||  suggestion.status === SUGGESTION_TYPES.DELETED_WIP) 
      || (suggestion.responseAccountId === suggestion.creatorId && suggestion.status === SUGGESTION_TYPES.REJECTED))) {
      nameRespondant = <div style={{color:respondant.color}} className={classes.chatMessageSender}>{respondant.firstName}</div>
      avatarRespondant = <ImgAvatar imgName={respondant.avatar} color={respondant.color} border={true} 
        style={{width: 28,height: 28, borderWidth:'2px'}} imgUrl={respondant.imageAvatar ? respondant.avatarURL : undefined} />;

      timeRespondant = <div className={classes.chatTime} style={suggestion.creatorId === userId?{left:'4px'}:{right:'4px'}}>
        {tn.formatDateYearMonthDay(new Date(suggestion.responseTime))}
      </div>

      if (suggestion.status === SUGGESTION_TYPES.ACCEPTED_AND_EXECUTED || suggestion.status === SUGGESTION_TYPES.ACCEPTED_AND_EXECUTED_ON_WIP ) {
        response = <AcceptIcon style={{fill:'#93A37C', fontSize:'24px', padding: '6px 10px', alignSelf: 'center'}}/>;
      } else if (suggestion.status === SUGGESTION_TYPES.REJECTED ) {
        response = <DeclineIcon style={{fill:'#D96159', fontSize:'24px', padding: '6px 10px', alignSelf: 'center'}}/>
      }
    }


    const leftName:JSX.Element|undefined  = suggestion.creatorId === userId ? nameRespondant: nameCreator;
    const leftAvatar:JSX.Element|undefined  = suggestion.creatorId === userId ? avatarRespondant: avatarCreator;
    const leftTime:JSX.Element|undefined  = suggestion.creatorId === userId ? timeRespondant : timeCreated;
    const leftResponse:JSX.Element|null|undefined  = suggestion.creatorId === userId ? response : this.renderSuggestion();

    const rightName:JSX.Element|undefined = suggestion.creatorId === userId ? nameCreator: nameRespondant;
    const rightAvatar:JSX.Element|undefined  = suggestion.creatorId === userId ? avatarCreator: avatarRespondant;
    const rightTime:JSX.Element|undefined  = suggestion.creatorId === userId ? timeCreated: timeRespondant;
    const rightResponse:JSX.Element|null|undefined  = suggestion.creatorId === userId ? this.renderSuggestion(): response;


    return (
      <div className={classes.chatMessage} style={{padding:'10px 0px'}}>
        {leftResponse && <div className={classes.chatMessageIcon}>
          {leftAvatar}
        </div>}
        {leftResponse && <div className={classes.chatMessageMsg+" "+classes.chatMessageMsgLastLeft}>
          {leftName}
          {leftResponse}
          {leftTime}
        </div>}
        <div className={classes.chatMessageSpace} />
        {rightResponse && <div className={classes.chatMessageMsg+" "+classes.chatMessageMsgLastRight}>
          {rightName}
          {rightResponse}
          {rightTime}
        </div>}
        {rightResponse && <div className={classes.chatMessageIcon}>
          {rightAvatar}
        </div>}
      </div>
    );

  }

  private renderSuggestion() {

    const {classes, suggestion, userId} = this.props;

    if (suggestion.schedules.length < 1 || suggestion.id === 0 || suggestion.publishTime === undefined) {
      return (<div>{tn.lang.unknown+ " "+tn.lang.calOldSuggestions}</div>);
    }
    const scheduleId = suggestion.schedules[0]

    if (suggestion.responseAccountId === 0 && suggestion.changes && suggestion.changes.length > 0 
      && suggestion.changes[0].type === SUGGESTION_CHANGE_TYPES.SHARE) {
      return (
          <Link to={"/app/calendar/"+scheduleId+"/0"} style = {{textDecoration: 'none', color: styleColors.greyDark2}} >
            <div className={classes.chatSuggestion}>
              {tn.lang.scheduleName(scheduleId)+ " " + tn.lang.shared}
            </div>
          </Link>);
    } else if (suggestion.responseAccountId !== 0) {
      let clickable=suggestion.status === SUGGESTION_TYPES.AWAITING_APPROVAL;
      
      let icon:JSX.Element = <InfoIcon style={{fontSize:'24px'}} />
      if (suggestion.status === SUGGESTION_TYPES.DELETED ||  suggestion.status === SUGGESTION_TYPES.DELETED_WIP 
        || (suggestion.responseAccountId === suggestion.creatorId && suggestion.status === SUGGESTION_TYPES.REJECTED)) {
        icon = <DeleteIcon style={{fontSize:'24px'}} />
        clickable = false;
      } else if (suggestion.status === SUGGESTION_TYPES.AWAITING_APPROVAL) {
        icon = <ReplyIcon style={{fontSize:'24px'}} />
      }

      if (clickable) {
        return (
            <Link to={"/app/calendar/"+scheduleId+"/"+suggestion.id} 
              style = {{textDecoration: 'underline', color: styleColors.greyDark2}} >
              <div className={classes.chatSuggestion}>
                {tn.lang.suggestionName(suggestion.id)}
                {icon}
              </div>
            </Link>);    
      } else {
        return (
          <div onClick={() => this.props.showSuggestionDetails()}>
            <div className={classes.chatSuggestion} style={{textDecoration: 'underline'}}>
              {tn.lang.suggestionName(suggestion.id)}
              {icon}
            </div>
          </div>);   
      }
    } else {
      return undefined;
    }
  }

}


export default (withStyles(ChatStyle)(ChatSuggestionMessage));



// WEBPACK FOOTER //
// ./src/components/chat/ChatSuggestionMessage.tsx